export default {
  title: {
    en: 'Your payment could not be processed',
  },
  text: {
    en: `
    Unfortunately, we’re only able to accept prepaid cards for multi-month subscriptions,
    which are paid upfront and non-refundable.<br />
    <b>But you’re the real winner here: check out our discounts!</b>
  `,
  },
  orderButton: {
    en: 'Place order',
  },
}
